export default __webpack_public_path__ + "static/media/text2.eebcebb4.png";